<template>
  <div class="content album-detail-page">
    <el-form
        :model="updateAlbumRequest"
        :rules="rules"
        ref="updateAlbumRequest"
        label-width="120px"
        class="demo-ruleForm album-form"
    >
      <!-- Header card -->
      <div class="page-header-card">
        <div>
          <h2 class="page-title">Chi tiết album</h2>
          <p class="page-description">
            Chỉnh sửa thông tin album, thêm ảnh mới hoặc duyệt ảnh đã tải lên.
          </p>
        </div>
        <div class="header-badges">
          <div class="summary-badge">
            <span class="summary-badge__label">Đối tượng</span>
            <strong class="summary-badge__value">
              {{ updateAlbumRequest.selectObject === 'student' ? 'Lớp' : 'Trường' }}
            </strong>
          </div>
          <div class="summary-badge">
            <span class="summary-badge__label">Ảnh đã duyệt</span>
            <strong class="summary-badge__value">
              {{ updateAlbumRequest.pictureApprovedNumber || 0 }}/{{ updateAlbumRequest.pictureNumber || 0 }}
            </strong>
          </div>
        </div>
      </div>

      <div class="form-shell">
        <!-- Thông tin album -->
        <section class="section-card">
          <div class="section-heading">
            <div>
              <h3 class="section-title">Thông tin album</h3>
              <p class="section-description">Chỉnh sửa tên, đối tượng và mô tả album.</p>
            </div>
          </div>

          <el-row :gutter="20">
            <el-col :xs="24" :md="12">
              <el-form-item class="field-item" label="Tên album" prop="albumName">
                <el-input
                    v-model="updateAlbumRequest.albumName"
                    placeholder="Nhập tiêu đề..."
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12">
              <el-form-item class="field-item" label="Đối tượng">
                <el-select
                    @change="handleChangeObject"
                    v-model="updateAlbumRequest.selectObject"
                    placeholder="Chọn đối tượng"
                    class="full-width"
                >
                  <el-option
                      v-for="item in listSelectObject"
                      :key="item.id"
                      :label="item.label"
                      :value="item.value"
                  >
                    <span>{{ item.label }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item class="description-item" label="Mô tả album" prop="desc">
            <el-input
                v-model="updateAlbumRequest.albumDescription"
                placeholder="Nhập nội dung..."
                :rows="3"
                type="textarea"
            ></el-input>
          </el-form-item>
        </section>

        <!-- Phạm vi học sinh -->
        <section v-if="updateAlbumRequest.selectObject === 'student'" class="section-card">
          <div class="section-heading section-heading--space-between">
            <div>
              <h3 class="section-title">Phạm vi học sinh</h3>
              <p class="section-description">Chọn học sinh áp dụng cho album theo từng lớp.</p>
            </div>
            <el-button
                @click="clickSelectStudent"
                type="primary"
                icon="el-icon-user"
                class="student-select-button"
            >
              Chọn học sinh trong lớp
            </el-button>
          </div>

          <div class="student-list-panel">
            <div class="student-list-panel__header">
              <div>
                <h4 class="student-list-title">Danh sách học sinh</h4>
                <span class="student-list-subtitle">
                  Đã chọn {{ updateAlbumRequest.kids ? updateAlbumRequest.kids.length : 0 }} học sinh
                </span>
              </div>
            </div>

            <div v-if="!updateAlbumRequest.kids || updateAlbumRequest.kids.length === 0" class="student-empty-state">
              <i class="el-icon-user-solid student-empty-state__icon"></i>
              <div class="student-empty-state__title">Chưa có học sinh nào được chọn</div>
              <div class="student-empty-state__desc">
                Nhấn <strong>Chọn học sinh trong lớp</strong> để thêm học sinh vào album này.
              </div>
            </div>

            <div v-else class="answer_apply">
              <div v-for="(kid, index) in updateAlbumRequest.kids" :key="index" class="kid-row">
                <div class="kid-row__icon-wrap">
                  <i class="el-icon-circle-check kid-row__icon"/>
                </div>
                <div class="kid-row__content">
                  <div class="kid-row__name">{{ kid.kidsName }}</div>
                  <div class="kid-row__meta">
                    {{ parseKidStatusVietnamese(kid.statusKids) }} • {{ kid.className }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Thêm ảnh mới -->
        <section class="section-card">
          <div class="section-heading">
            <div>
              <h3 class="section-title">Thêm ảnh mới</h3>
              <p class="section-description">Tải ảnh lên để bổ sung vào album.</p>
            </div>
          </div>

          <div class="upload-toolbar">
            <div class="upload-left">
              <div class="upload-note-card">
                <span class="upload-note-card__label">Đang chờ tải lên</span>
                <strong class="upload-note-card__value">{{ fileList.length }} ảnh</strong>
              </div>

              <div class="selected-summary" v-if="fileList && fileList.length > 0">
                <img :src="fileList[0].url" class="selected-summary__thumb" alt="ảnh"/>
                <div class="selected-summary__text">{{ fileList.length }} ảnh đã chọn</div>
              </div>
              <div class="selected-summary" v-else>
                <div class="selected-summary__empty">Chưa có ảnh mới</div>
              </div>
            </div>

            <div class="upload-right">
              <div class="progress-wrap" v-if="showProgress">
                <el-progress
                    class="upload-progress"
                    :percentage="percentage"
                    :color="colors"
                ></el-progress>
                <div class="progress-label">{{ percentage }}%</div>
              </div>
            </div>
          </div>

          <el-upload
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              ref="upload"
              :file-list="fileList"
              :on-change="handleChangePicture"
              :on-remove="handleRemove"
              multiple
              class="upload-area"
          >
            <template #default>
              <div class="upload-trigger">
                <i class="el-icon-plus upload-trigger__icon"></i>
                <span class="upload-trigger__text">Thêm ảnh</span>
              </div>
            </template>
            <template #file="{ file }">
              <div class="container_image_upload">
                <TagFlag title="Mới"/>
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt/>
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </template>
          </el-upload>

          <el-dialog width="30%" :visible.sync="dialogVisible" top="50px">
            <img width="100%" :src="dialogImageUrl" alt/>
          </el-dialog>
        </section>

        <!-- Danh sách ảnh album -->
        <section class="section-card">
          <div class="section-heading">
            <div>
              <h3 class="section-title">
                Danh sách ảnh album
                <span class="album-name-inline" v-if="updateAlbumRequest.albumName">
                  — {{ updateAlbumRequest.albumName }}
                </span>
              </h3>
              <p class="section-description">Xem, duyệt hoặc xóa ảnh đã có trong album.</p>
            </div>
          </div>

          <div
              v-if="Array.isArray(updateAlbumRequest.alistPictureList) && updateAlbumRequest.alistPictureList.length"
              class="picture-grid"
          >
            <div
                v-for="(listPicture, index) in updateAlbumRequest.alistPictureList"
                :key="index"
                class="picture-card"
            >
              <div class="picture-card__img-wrap">
                <el-tooltip content="Xem ảnh" placement="top">
                  <el-image
                      @click="handleShowDetailPicture(index, listPicture)"
                      :src="listPicture.urlPictureShow"
                      class="picture-card__img el-image-opacity"
                      fit="cover"
                  ></el-image>
                </el-tooltip>
                <div class="picture-card__badge" :class="listPicture.isApproved ? 'badge--approved' : 'badge--pending'">
                  {{ listPicture.isApproved ? 'Đã duyệt' : 'Chờ duyệt' }}
                </div>
              </div>

              <div class="picture-card__actions" v-if="checkPermission(['studentQuality_ablum_update'])">
                <el-button
                    v-if="!listPicture.isApproved"
                    type="primary"
                    size="mini"
                    icon="el-icon-check"
                    class="picture-card__btn"
                    @click="updateApprovePicture(listPicture.id, true)"
                >Duyệt</el-button>
                <el-button
                    v-else
                    type="success"
                    size="mini"
                    icon="el-icon-check"
                    class="picture-card__btn picture-card__btn--approved"
                    disabled
                >Đã duyệt</el-button>
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    class="picture-card__btn"
                    @click="deletePicture(listPicture.id)"
                ></el-button>
              </div>
            </div>
          </div>

          <div v-else class="pictures-empty-state">
            <i class="el-icon-picture-outline pictures-empty-state__icon"></i>
            <div class="pictures-empty-state__title">Album chưa có ảnh nào</div>
            <div class="pictures-empty-state__desc">Hãy tải ảnh lên ở phần "Thêm ảnh mới" phía trên.</div>
          </div>
        </section>
      </div>

      <!-- Footer actions -->
      <div class="actions-footer">
        <div class="actions-footer__left">
          <span class="meta-author"><strong>Người đăng:</strong> {{ updateAlbumRequest.createdBy }}</span>
          <span class="meta-divider">|</span>
          <span class="meta-info">{{ updateAlbumRequest.pictureApprovedNumber }}/{{ updateAlbumRequest.pictureNumber }} ảnh</span>
          <span class="meta-divider">|</span>
          <span class="meta-info">{{ updateAlbumRequest.createdDate | formatDate }}</span>
        </div>
        <div class="actions-footer__right">
          <el-button
              v-if="checkPermission(['studentQuality_ablum_update'])"
              class="button-over"
              type="success"
              @click="submitUpload('updateAlbumRequest')"
              icon="el-icon-circle-check"
              :loading="loadingButton"
              :disabled="loadingButton || compressingCount > 0"
          >
            Lưu thay đổi
          </el-button>
          <el-button
              v-if="checkPermission(['studentQuality_ablum_update'])"
              class="button-over"
              type="warning"
              icon="el-icon-finished"
              @click="updateAllApprovePicture(updateAlbumRequest.id)"
          >
            Duyệt tất cả
          </el-button>
          <router-link to="/student-quality/album" class="cancel-link">
            <el-button class="button-over" type="danger" icon="el-icon-back" @click="createEmployeeDialog()">
              Quay lại
            </el-button>
          </router-link>
        </div>
      </div>
    </el-form>

    <!-- Dialog xem ảnh chi tiết -->
    <el-dialog class="album-preview-dialog" width="55%" :visible.sync="dialogVisiblePic" top="25px">
      <div class="image-container">
        <img class="centered-image" :src="selectedImg" alt="Ảnh album"/>
        <div class="button-container">
          <el-button
              @click="backPage"
              type="primary"
              icon="el-icon-d-arrow-left"
              :disabled="indexSrc <= 0"
          >Trước</el-button>
          <el-button type="success" @click="setUpAvatarAlbum">Đặt làm ảnh đại diện</el-button>
          <el-button
              @click="nextPage"
              type="primary"
              :disabled="indexSrc >= alistPictureList.length - 1"
          >Sau <i class="el-icon-d-arrow-right"></i></el-button>
        </div>
      </div>
    </el-dialog>

    <AddStudentUpdateAlbumDialog
        :kidsInSchool="kidsInSchool"
        :getAppTypeUserLogin="getAppTypeUserLogin"
        :isAddStudentUpdateAlbumDialog="isAddStudentUpdateAlbumDialog"
        @closeDialog="closeAddStudentUpdateAlbumDialog"
        @confirmData="handleConfirmKidsApply"
    />
  </div>
</template>

<script>
import checkPermission from "@/utils/permission.js";
import AlbumService from "../../services/AlbumService";
import {mapState} from "vuex";
import pica from "pica";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import albumService from "@/services/AlbumService";
import TagFlag from "@/views/tag/TagFlag.vue";
import AddStudentUpdateAlbumDialog from "@/views/album/AddStudentUpdateAlbumDialog.vue";
import SurveyForm from "@/services/SurveyForm";
import parseInfoKidVietnameseMixin from "@/global/mixinKid/parseInfoKidVietnamese.mixin";

export default {
  components: {AddStudentUpdateAlbumDialog, TagFlag},
  data() {
    return {
      colors: [
        {color: "#f56c6c", percentage: 20},
        {color: "#e6a23c", percentage: 40},
        {color: "#5cb87a", percentage: 60},
        {color: "#1989fa", percentage: 80},
        {color: "#6f7ad3", percentage: 100},
      ],
      percentage: 0,
      interval: "",
      showProgress: false,
      classList: [],
      updateAlbumRequest: {},
      rules: {
        albumName: [
          {
            required: true,
            message: "Tên Album không được được để trống",
            trigger: "blur",
          },
        ],
      },
      // files: [],
      selectedFiles: undefined,
      currentFile: undefined,
      fileInfos: [],
      layout: "sizes, prev, pager, next",
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVisiblePic: false,
      indexSrc: 0,
      disabled: false,
      showCreateDialog: false,
      showUpdateDialog: false,
      idList: [],
      srcs: [
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%202.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%203.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%2013.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%2014.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%207.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%202.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%202.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%207.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%2013.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%207.jpg",
      ],
      alistPictureList: [],
      selectedImg: "",
      currentPage: "",
      totalPages: "",
      qualityPicture: "",
      widthPicture: "",
      listUpdate: [],
      idUpdate: 0,
      maxSizeListImage: null,
      loadingButton: false,
      isAddStudentUpdateAlbumDialog: false,
      kidsInSchool: [],
      classesApply: [],
      kidsDataFilter:[],
      compressingCount: 0,
      compressPromises: [],
      picaResizer: null,
    };
  },
  created() {
    this.picaResizer = pica({
      features: ["js", "wasm", "ww"],
    });
    this.$store.dispatch('classStore/fetchDataClassListCommon');
    this.runSequentially();
    this.handleChangeObject()
    // this.getSyConfigPicture();
    // this.fetchSizeListImage();
    // this.fetchKidsInSchool();
    // this.handleChangeObject()
    // this.getAlumDetail()
  },
  mixins: [
    parseInfoKidVietnameseMixin,
  ],
  computed: {
    ...mapState('classStore', ['classInTeacher']),
    ...mapState('classStore', ['classListCommon']),
    listClass() {
      if (this.getAppTypeUserLogin === "plus") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.classList = this.classListCommon;
      } else if (this.getAppTypeUserLogin === "teacher") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.classList = this.classInTeacher;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.classList.push({id: 0, className: "Trường"});
      return this.classList;
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    listSelectObject() {
      if (this.getAppTypeUserLogin === "plus") {
        return [
          { id: 1, value: "school", label: "Trường" },
          { id: 2, value: "student", label: "Lớp" },
        ];
      } else if (this.getAppTypeUserLogin === "teacher") {
        return [
          { id: 2, value: "student", label: "Lớp" },
        ];
      }
    },
  },

  methods: {
    checkPermission,
    handleChangeObject(){
      if (this.updateAlbumRequest.selectObject === "school") {
        this.updateAlbumRequest.listIdKidApply = []
        this.updateAlbumRequest.classes = []
        this.updateAlbumRequest.kids = []
      }
    },
    async fetchKidsInSchool() {
      await SurveyForm.getAllKidsSchool()
          .then((res) => {
            this.kidsInSchool = res.data.data;
          })
          .catch((err) => {
            console.log(err);
          })
    },
    async runSequentially() {
      try {
        await this.getSyConfigPicture();
        await this.fetchSizeListImage();
        await this.fetchKidsInSchool();
        await this.getAlumDetail();
        // await this.handleChangeObject();
      } catch (error) {
        console.error('Error in sequential execution:', error);
      }
    },
    clickSelectStudent(){
      this.isAddStudentUpdateAlbumDialog = true
    },
    closeAddStudentUpdateAlbumDialog(){
      this.isAddStudentUpdateAlbumDialog = false
    },
    async getSyConfigPicture() {
      await AlbumService.getSyConfigPicture().then((response) => {
        this.qualityPicture = response.data.data.qualityPicture;
        this.widthPicture = response.data.data.widthPicture;
      })
    },
    handleConfirmKidsApply(value) {
      this.updateAlbumRequest.classes = value.classesApply;
      this.updateAlbumRequest.kids = value.kidsApply;
      this.updateAlbumRequest.listIdKidApply = []
      for (let i = 0; i < this.updateAlbumRequest.kids.length; i++) {
        this.updateAlbumRequest.listIdKidApply.push(this.updateAlbumRequest.kids[i].idKid);
      }
      this.closeAddStudentUpdateAlbumDialog();
    },
    increase() {
      this.interval = window.setInterval(() => {
        this.percentage += 5;
        if (this.percentage > 90) {
          this.percentage = 90;
        }
      }, 50);
    },
    stopIncrease() {
      clearInterval(this.interval);
      this.percentage = 100;
    },
    handleChangePicture(file, fileList) {
      this.fileList = fileList
      if (!file || !file.raw) {
        return false;
      }
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG) {
        this.$message.error("Ảnh phải có dạng JPG hoặc PNG!");
        this.handleRemove(file);
        return false;
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không thể vượt quá 5MB");
        this.handleRemove(file);
        return false;
      }

      this.compressingCount += 1;
      const compressPromise = this.compressImage(file.raw, file.name, file.uid)
          .then((compressedFile) => {
            const existedIndex = this.listUpdate.findIndex(item => item.uid === compressedFile.uid);
            if (existedIndex >= 0) {
              this.listUpdate.splice(existedIndex, 1, compressedFile);
            } else {
              this.listUpdate.push(compressedFile);
            }
          })
          .catch((error) => {
            console.error("Compression error:", error);
            this.$message.error(`Nén ảnh thất bại: ${file.name}`);
          })
          .finally(() => {
            this.compressingCount = Math.max(0, this.compressingCount - 1);
          });

      this.compressPromises.push(compressPromise);
      compressPromise.finally(() => {
        this.compressPromises = this.compressPromises.filter(p => p !== compressPromise);
      });
      return true;
    },
    loadImage(file) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        const objectUrl = URL.createObjectURL(file);
        image.onload = () => {
          URL.revokeObjectURL(objectUrl);
          resolve(image);
        };
        image.onerror = (error) => {
          URL.revokeObjectURL(objectUrl);
          reject(error);
        };
        image.src = objectUrl;
      });
    },
    async compressImage(file, fileName, uid) {
      const image = await this.loadImage(file);
      const maxWidthConfig = parseInt(this.widthPicture);
      const maxWidth = Number.isFinite(maxWidthConfig) && maxWidthConfig > 0 ? maxWidthConfig : 1280;
      const ratio = Math.min(1, maxWidth / image.width);
      const targetWidth = Math.max(1, Math.round(image.width * ratio));
      const targetHeight = Math.max(1, Math.round(image.height * ratio));

      const sourceCanvas = document.createElement("canvas");
      sourceCanvas.width = image.width;
      sourceCanvas.height = image.height;
      const sourceContext = sourceCanvas.getContext("2d");
      sourceContext.drawImage(image, 0, 0);

      const resultCanvas = document.createElement("canvas");
      resultCanvas.width = targetWidth;
      resultCanvas.height = targetHeight;

      await this.picaResizer.resize(sourceCanvas, resultCanvas);

      const qualityConfig = parseInt(this.qualityPicture);
      const quality = Number.isFinite(qualityConfig) && qualityConfig > 0 ? Math.min(1, qualityConfig / 100) : 0.8;
      const outputType = file.type === "image/png" ? "image/png" : "image/jpeg";
      const resultBlob = await this.picaResizer.toBlob(resultCanvas, outputType, quality);

      const lastDot = fileName.lastIndexOf(".");
      const originalFilename = lastDot > 0 ? fileName.substring(0, lastDot) : fileName;
      const extension = outputType === "image/png" ? "png" : "jpg";
      const compressedFile = new File([resultBlob], `${originalFilename}_compressed.${extension}`, {type: outputType});
      compressedFile.uid = uid;
      return compressedFile;
    },

    async savePictureAlbum(id, fileList) {
      const groupFile = this.groupFilesBySize(fileList);

      try {
        // Tạo danh sách Promise upload
        const uploadPromises = groupFile.map(async (child) => {
          const formData = new FormData();
          formData.append("idAlbum", id);
          formData.append("isCreate", false);

          child.forEach((file, i) => {
            formData.append(`fileList[${i}]`, file);
          });

          // Gửi yêu cầu upload
          await AlbumService.savePictureAlbum(formData);
        });

        // Đợi tất cả file upload xong
        await Promise.all(uploadPromises);

        // Khi tất cả thành công, hiển thị thông báo & chuyển trang
        this.$message({
          message: "Cập nhật Album thành công",
          type: "success",
        });
        this.showProgress = false;
      } catch (error) {
        console.error(error);
        this.$message({
          message: "Lỗi lưu ảnh!",
          type: "danger",
        });
      } finally {
        this.$refs.upload.clearFiles();
        this.showProgress = false;
        this.loadingButton = false;
        this.getAlumDetail();
        this.stopIncrease();
      }
    },

    groupFilesBySize(files) {
      const maxSize = this.maxSizeListImage * 1024 * 1024; // 10MB in bytes
      let groups = [];
      let currentGroup = [];
      let currentSize = 0;

      for (let file of files) {
        const fileSize = file.size;

        // Nếu thêm file này vào nhóm hiện tại không vượt quá 10MB, thêm vào
        if (currentSize + fileSize <= maxSize) {
          currentGroup.push(file);
          currentSize += fileSize;
        } else {
          // Nếu vượt quá, tạo một nhóm mới và thêm file vào nhóm đó
          groups.push(currentGroup);
          currentGroup = [file];
          currentSize = fileSize;
        }
      }

      // Đừng quên thêm nhóm cuối cùng nếu có
      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }

      return groups;

    },

    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold";
    },
    //highlight cho row theo điều kiện
    tableRowStyle({row}) {
      row.id;
    },
    submitUpload(fromData) {
      this.$refs[fromData].validate(async (valid) => {
        if (valid) {
          if (this.compressPromises.length > 0) {
            this.$message.info("Dang nen anh, vui long cho...");
            await Promise.allSettled(this.compressPromises);
          }
          if (this.fileList.length > 0 && this.listUpdate.length === 0) {
            this.$message.warning("Chua co anh hop le sau khi nen. Vui long thu lai.");
            return;
          }
          this.loadingButton = true;
          this.updateAlbumRequest.fileList = this.listUpdate;
          this.showProgress = true;
          let formData = new FormData();
          formData.append("albumName", this.updateAlbumRequest.albumName);
          formData.append(
              "albumDescription",
              this.updateAlbumRequest.albumDescription
          );
          formData.append("albumType", this.updateAlbumRequest.albumType);
          formData.append(
              "albumApprovalDefault",
              this.updateAlbumRequest.albumApprovalDefault
          );
          formData.append(
              "idSchoolApproval",
              this.updateAlbumRequest.idSchoolApproval
          );
          formData.append(
              "schoolApprovalDate",
              this.updateAlbumRequest.schoolApprovalDate
          );
          formData.append(
              "urlPictureFirst",
              this.updateAlbumRequest.urlPictureFirst
          );
          formData.append(
              "pictureNumber",
              this.updateAlbumRequest.pictureNumber
          );
          formData.append(
              "pictureApprovedNumber",
              this.updateAlbumRequest.pictureApprovedNumber
          );
          if (this.updateAlbumRequest.listIdKidApply !== null){
            formData.append("listIdKidApply", this.updateAlbumRequest.listIdKidApply);
          }

          formData.append("selectObject", this.updateAlbumRequest.selectObject);
          if (this.updateAlbumRequest.selectObject === "school"){
            formData.append("idClass", "0");
          }else {
            formData.append("idClass", this.updateAlbumRequest.classes[0]);
          }
          formData.append("idSchool", this.updateAlbumRequest.idSchool);
          formData.append("id", this.updateAlbumRequest.id);
          formData.append(
              "listPictureList",
              this.updateAlbumRequest.alistPictureList
          );
          formData.append("countFileUp", this.updateAlbumRequest.fileList.length)

          this.increase();
          AlbumService.updateAlbumUploadNew(formData)
              .then(() => {

                if (this.updateAlbumRequest.fileList.length > 0) {
                  this.savePictureAlbum(this.updateAlbumRequest.id, this.updateAlbumRequest.fileList);
                } else {
                  this.stopIncrease();
                  NotifyMessage.leftCornerNotificationSuccess("Cập nhật Album thành công!")
                  this.showProgress = false;
                  this.loadingButton = false
                  this.getAlumDetail();
                }

              })
              .catch((err) => {
                this.loadingButton = false
                NotifyMessage.leftCornerNotificationError(err.response.data.message)
                clearInterval(this.interval);
                this.getAlumDetail();
                this.showProgress = false;
                this.loadingButton = false
              })
              .finally(() => {});
        }
      });
    },

    handleCommand(command) {
      if (command === "activeAccount") {
        this.updateMultiActivated();
      } else if (command === "unactiveAccount") {
        this.updateMultiUnActivated();
      } else if (command === "deleteMultiEmployee") {
        this.handleMultiDelelte();
      } else if (command === "exportExcel") {
        this.exportExcelEmployee();
      }
    },
    handleRemove(file) {
      this.$refs.upload.clearFiles();
      let indexAlbumRequest;
      for (let i = 0; i < this.listUpdate.length; i++) {
        if (file.uid === this.listUpdate[i].uid) {
          indexAlbumRequest = i
        }
      }
      let indexFile;
      for (let i = 0; i < this.fileList.length; i++) {
        if (file.uid === this.fileList[i].uid) {
          indexFile = i
        }
      }
      if (indexAlbumRequest >= 0) {
        this.listUpdate.splice(indexAlbumRequest, 1);
      }
      if (indexFile >= 0) {
        this.fileList.splice(indexFile, 1);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleShowDetailPicture(index, listPicture) {
      this.indexSrc = index;
      this.handleLinkUrl(listPicture);
      this.dialogVisiblePic = true;
    },

    nextPage() {
      this.indexSrc += 1;
      if (this.indexSrc === this.alistPictureList.length) {
        this.indexSrc = this.alistPictureList.length - 1;
      }
      this.handleLinkUrl(this.alistPictureList[this.indexSrc]);
    },
    backPage() {
      this.indexSrc -= 1;
      if (this.indexSrc < 0) {
        this.indexSrc = 0;
      }
      this.handleLinkUrl(this.alistPictureList[this.indexSrc]);
    },
    handleLinkUrl(listPicture) {
      this.selectedImg = listPicture.urlPicture;
      this.idUpdate = listPicture.id
    },
    handleDownload(file) {
      console.log(file);
    },
    //click edit at row
    handleEdit(index, row) {
      console.log(row);
    },
    createEmployeeDialog() {
      this.showCreateDialog = true;
    },
    dialogCloseCreateMethod() {
      this.showCreateDialog = false;
    },
    dialogCloseUpdateMethod() {
      this.showUpdateDialog = false;
    },
    // handleFile(file) {
    //   console.log(file);
    // },
    // handleFilesUpload() {
    //   let uploadedFiles = this.$refs.files.files;
    //   /*
    //       Adds the uploaded file to the files array
    //     */
    //   for (var i = 0; i < uploadedFiles.length; i++) {
    //     this.files.push(uploadedFiles[i]);
    //   }
    // },
    // addFiles() {
    //   this.$refs.files.click();
    // },
    getAlumDetail() {
      AlbumService.getAlbumById(this.$route.params.id)
          .then((res) => {
            this.updateAlbumRequest = res.data.data;
            // this.updateAlbumRequest.classes.push(this.updateAlbumRequest.idClass)

            this.classesApply.push(this.updateAlbumRequest.idClass)
            console.log("classesApply: ",  this.classesApply)
            this.updateAlbumRequest.classes = this.classesApply

            this.alistPictureList = res.data.data.alistPictureList;
            this.updateAlbumRequest.kids = []
            this.idKidApply = res.data.data.listIdKidApply
            if (this.idKidApply.length > 0) {
              for (let i = 0; i < this.idKidApply.length; i++) {
                for (let j = 0; j < this.kidsInSchool.length; j++) {
                  if (this.idKidApply[i] === this.kidsInSchool[j].idKid) {
                    this.updateAlbumRequest.kids.push(this.kidsInSchool[j])
                  }
                }
              }
            }
            console.log("kiem tra 4: ", this.updateAlbumRequest.kids)
          })
          .catch((e) => {
            console.log(e);
          });
    },

    deletePicture(id) {
      this.$confirm("Bạn có chắc chắn muốn xóa ảnh đã chọn?", "Thông báo!", {
        distinguishCancelAndClose: true,
        confirmButtonText: "Có",
        closeOnClickModal: false,
        cancelButtonText: "Không",
      }).then(() => {
        AlbumService.deletePicture(id)
            .then((res) => {
              if (res.data.data) {
                if (this.updateAlbumRequest.pictureNumber === 0) {
                  AlbumService.deleteAlbum(this.updateAlbumRequest.id).then(
                      (res) => {
                        if (res.data) {
                          this.$message({
                            message:
                                "Xóa Album " +
                                this.updateAlbumRequest.albumName +
                                " thành công",
                            type: "success",
                          });
                          this.$router.go("/student-quality/album");
                          this.getAlumDetail();
                        }
                      }
                  );
                } else {
                  this.$message({
                    message: "Xóa ảnh thành công",
                    type: "success",
                  });
                  this.getAlumDetail();
                }
              } else {
                this.$message({
                  message: "Xóa ảnh thất bại",
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message({
                message: "Lỗi xóa ảnh",
                type: "error",
              });
            });
      });
    },
    updateApprovePicture(id, check) {
      this.$confirm("Bạn có chắc chắn muốn duyệt ảnh đã chọn?", "Thông báo!", {
        distinguishCancelAndClose: true,
        confirmButtonText: "Có",
        closeOnClickModal: false,
        cancelButtonText: "Không",
      }).then(() => {
        AlbumService.updateApprovePicture(id, check)
            .then(() => {
              this.$message({
                message: "Duyệt ảnh thành công",
                type: "success",
              });
              // this.$router.go("/student-quality/album-detail/" + id);
              this.getAlumDetail();
            })
            .catch((err) => {
              console.log(err);
              this.$message({
                message: "Duyệt ảnh thất bại",
                type: "error",
              });
            });
      });
    },
    updateAllApprovePicture(id) {
      this.$confirm(
          "Bạn có chắc chắn muốn duyệt tất cả ảnh đã chọn?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
          }
      ).then(() => {
        AlbumService.updateAllApprovePicture(id)
            .then(() => {
              this.$message({
                message: "Duyệt tất cả các ảnh thành công",
                type: "success",
              });
              // this.$router.go("/student-quality/album-detail/" + id);
              this.getAlumDetail();
            })
            .catch((err) => {
              console.log(err);
              this.$message({
                message: "Duyệt tất cả các ảnh thất bại",
                type: "error",
              });
            });
      });
    },

    setUpAvatarAlbum() {
      AlbumService.setUpAvatarAlbum(this.idUpdate).then((response) => {
        if (response.data.data) {
          NotifyMessage.leftCornerNotificationSuccess("Thay đổi thành công")
        } else {
          NotifyMessage.leftCornerNotificationError("Thay đổi thất bại")
        }
      })
    },

    async fetchSizeListImage() {
     await albumService.getSizeListImage()
          .then(res => this.maxSizeListImage = res.data.data)
          .catch(err => console.error(err))
    },



  },

  // beforeMount() {
  //   this.getAlumDetail();
  //
  // },
};
</script>

<style lang="scss" scoped>
.album-detail-page {
  padding-bottom: 24px;

  .album-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  // ─── Header card ────────────────────────────────────────────────────────────
  .page-header-card,
  .form-shell {
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    border: 1px solid #e8edf4;
    border-radius: 18px;
    box-shadow: 0 10px 30px rgba(31, 45, 61, 0.08);
  }

  .page-header-card {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    padding: 24px 28px;
    overflow: hidden;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: -30px; right: -30px;
      width: 160px; height: 160px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(120,165,231,.22) 0%, rgba(120,165,231,0) 72%);
      pointer-events: none;
    }
  }

  .page-title {
    margin: 0 0 8px;
    color: #303133;
    font-size: 26px;
    font-weight: 700;
  }

  .page-description {
    margin: 0;
    max-width: 640px;
    color: #606266;
    line-height: 1.6;
  }

  .header-badges {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    position: relative;
    z-index: 1;
  }

  .summary-badge {
    min-width: 150px;
    padding: 14px 16px;
    border-radius: 14px;
    background: #f5f9ff;
    border: 1px solid #dbe8fb;
  }

  .summary-badge__label {
    display: block;
    margin-bottom: 6px;
    color: #909399;
    font-size: 12px;
  }

  .summary-badge__value {
    color: #303133;
    font-size: 18px;
    font-weight: 700;
  }

  // ─── Form shell ─────────────────────────────────────────────────────────────
  .form-shell {
    padding: 28px;
  }

  .section-card {
    padding: 24px;
    border-radius: 16px;
    background: #ffffff;
    border: 1px solid #edf2f8;
  }

  .section-card + .section-card {
    margin-top: 20px;
  }

  .section-heading {
    margin-bottom: 20px;
  }

  .section-heading--space-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .section-title {
    margin: 0 0 6px;
    color: #303133;
    font-size: 18px;
    font-weight: 700;
  }

  .album-name-inline {
    color: #78a5e7;
    font-weight: 600;
  }

  .section-description {
    margin: 0;
    color: #909399;
    line-height: 1.5;
  }

  .field-item,
  .description-item {
    margin-bottom: 0;
  }

  .description-item {
    margin-top: 8px;
  }

  .full-width,
  .full-width /deep/ .el-input {
    width: 100%;
  }

  // ─── Students ───────────────────────────────────────────────────────────────
  .student-select-button { flex-shrink: 0; }

  .student-list-panel {
    border-radius: 16px;
    background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
    border: 1px solid #dfeafb;
    overflow: hidden;
  }

  .student-list-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px;
    background: linear-gradient(90deg, #78a5e7 0%, #91b7ef 100%);
  }

  .student-list-title {
    margin: 0 0 4px;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
  }

  .student-list-subtitle {
    color: rgba(255,255,255,.9);
    font-size: 13px;
  }

  .student-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 180px;
    padding: 24px;
    text-align: center;
    color: #606266;
  }

  .student-empty-state__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 68px; height: 68px;
    border-radius: 50%;
    background: #edf4ff;
    color: #78a5e7;
    font-size: 28px;
  }

  .student-empty-state__title {
    color: #303133;
    font-size: 18px;
    font-weight: 700;
  }

  .student-empty-state__desc {
    max-width: 380px;
    line-height: 1.6;
  }

  .answer_apply {
    max-height: 260px;
    padding: 16px;
    overflow: auto;
  }

  .kid-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    background: #fff;
  }

  .kid-row + .kid-row { margin-top: 10px; }

  .kid-row__icon-wrap {
    flex-shrink: 0;
    width: 28px; height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(103,194,58,.12);
  }

  .kid-row__icon { color: #67c23a; font-size: 16px; }
  .kid-row__content { min-width: 0; }
  .kid-row__name { color: #303133; font-weight: 600; line-height: 1.5; word-break: break-word; }
  .kid-row__meta { margin-top: 2px; color: #909399; line-height: 1.5; word-break: break-word; }

  // ─── Upload toolbar ─────────────────────────────────────────────────────────
  .upload-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 18px;
  }

  .upload-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .upload-note-card {
    padding: 12px 16px;
    border-radius: 14px;
    background: #fff8eb;
    border: 1px solid #f6dca7;
  }

  .upload-note-card__label {
    display: block;
    margin-bottom: 4px;
    color: #c48a13;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: .05em;
  }

  .upload-note-card__value { color: #8a5b00; font-size: 16px; }

  .selected-summary {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 10px;
    border-radius: 12px;
    background: #f6f9ff;
    border: 1px solid #e6eefc;
  }

  .selected-summary__thumb {
    width: 48px; height: 48px;
    object-fit: cover;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(31,45,61,.06);
  }

  .selected-summary__text { font-size: 13px; color: #303133; font-weight: 600; }
  .selected-summary__empty { color: #909399; font-size: 13px; }

  .upload-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 220px;
  }

  .progress-wrap { display: flex; align-items: center; gap: 8px; }
  .upload-progress { width: 280px; max-width: 100%; }
  .progress-label { color: #303133; font-weight: 700; font-size: 13px; min-width: 40px; text-align: right; }

  .upload-area /deep/ .el-upload--picture-card,
  .upload-area /deep/ .el-upload-list--picture-card .el-upload-list__item {
    border-radius: 16px;
  }

  .upload-area /deep/ .el-upload--picture-card {
    width: 160px; height: 160px;
    border: 1px dashed #b8cdf3;
    background: linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .upload-area /deep/ .el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
  }

  .upload-trigger {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 6px 8px;
    width: 100%; height: 100%;
    color: #5b84c4;
  }

  .upload-trigger__icon { font-size: 20px; line-height: 1; display: inline-flex; align-items: center; justify-content: center; }
  .upload-trigger__text { font-size: 15px; font-weight: 600; }

  // ─── Picture grid ────────────────────────────────────────────────────────────
  .picture-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 16px;
  }

  .picture-card {
    border-radius: 14px;
    border: 1px solid #edf2f8;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(31,45,61,.06);
    transition: box-shadow .2s ease;

    &:hover { box-shadow: 0 8px 24px rgba(31,45,61,.12); }
  }

  .picture-card__img-wrap {
    position: relative;
    height: 150px;
    overflow: hidden;
  }

  .picture-card__img {
    width: 100%; height: 150px;
    cursor: pointer;

    /deep/ .el-image__inner { object-fit: cover; width: 100%; height: 100%; }
  }

  .el-image-opacity { cursor: pointer; }

  .picture-card__badge {
    position: absolute;
    top: 8px; right: 8px;
    padding: 3px 8px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .03em;
  }

  .badge--approved  { background: rgba(103,194,58,.9);  color: #fff; }
  .badge--pending   { background: rgba(230,162,60,.9);  color: #fff; }

  .picture-card__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px;
    gap: 4px;
  }

  .picture-card__btn {
    flex: 1;
    padding: 6px 8px;
    font-size: 12px;
    border-radius: 8px !important;
  }

  .picture-card__btn--approved { opacity: .6; }

  .pictures-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    min-height: 200px;
    text-align: center;
    color: #606266;
  }

  .pictures-empty-state__icon {
    display: flex; align-items: center; justify-content: center;
    width: 72px; height: 72px;
    border-radius: 50%;
    background: #f0f6ff;
    color: #78a5e7;
    font-size: 32px;
  }

  .pictures-empty-state__title { color: #303133; font-size: 18px; font-weight: 700; }
  .pictures-empty-state__desc  { max-width: 360px; line-height: 1.6; }

  // ─── Footer actions ──────────────────────────────────────────────────────────
  .actions-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    padding: 16px 20px;
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    border: 1px solid #e8edf4;
    border-radius: 14px;
    box-shadow: 0 4px 16px rgba(31,45,61,.06);
  }

  .actions-footer__left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    color: #606266;
    font-size: 14px;
  }

  .meta-author { color: #303133; }
  .meta-divider { color: #dcdfe6; }
  .meta-info { color: #606266; }

  .actions-footer__right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .button-over {
    min-width: 140px;
    border-radius: 10px !important;
    box-shadow: 0 8px 20px rgba(48,49,51,.08);
  }

  .cancel-link { text-decoration: none; }

  // ─── Form inputs ─────────────────────────────────────────────────────────────
  /deep/ .el-form-item__label { color: #303133; font-weight: 600; }

  /deep/ .el-input .el-input__inner,
  /deep/ .el-select .el-input__inner,
  /deep/ .el-textarea__inner {
    border-radius: 10px;
    border-color: #dbe4f0;
    transition: all .2s ease;
  }

  /deep/ .el-input .el-input__inner,
  /deep/ .el-select .el-input__inner {
    height: 42px;
    line-height: 42px;
  }

  /deep/ .el-input .el-input__inner:focus,
  /deep/ .el-select .el-input__inner:focus,
  /deep/ .el-textarea__inner:focus {
    border-color: #78a5e7;
    box-shadow: 0 0 0 3px rgba(120,165,231,.12);
  }

  /deep/ .el-textarea__inner { min-height: 100px !important; }

  // ─── Dialog ─────────────────────────────────────────────────────────────────
  .container_image_upload {
    position: relative;
    height: 100%;
    img { object-fit: cover; }
  }

  .album-preview-dialog /deep/ .el-dialog {
    border-radius: 14px;
    overflow: hidden;
  }

  .album-preview-dialog /deep/ .el-dialog__body {
    padding: 16px;
    background: #f8fbff;
  }

  .centered-image {
    max-height: 68vh;
    max-width: 100%;
    margin: 0 auto;
    border-radius: 12px;
    object-fit: contain;
    box-shadow: 0 6px 20px rgba(31, 45, 61, .14);
    background: #fff;
    display: block;
  }

  .image-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
  }

  .button-container {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 10px;
    width: 100%;
    margin-top: 2px;
  }

  .button-container /deep/ .el-button {
    min-height: 38px;
    border-radius: 10px;
  }

  // ─── Responsive ──────────────────────────────────────────────────────────────
  @media (max-width: 992px) {
    .page-header-card,
    .section-heading--space-between {
      flex-direction: column;
      align-items: flex-start;
    }

    .header-badges { width: 100%; }
    .summary-badge { flex: 1 1 180px; }

    .picture-grid {
      grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    }

    .album-preview-dialog /deep/ .el-dialog {
      width: 80% !important;
    }
  }

  @media (max-width: 768px) {
    .page-header-card, .form-shell { border-radius: 14px; }
    .page-header-card, .form-shell, .section-card { padding: 16px; }
    .section-card + .section-card { margin-top: 16px; }

    .actions-footer { flex-direction: column; align-items: stretch; }

    .actions-footer__right {
      flex-direction: column;
      align-items: stretch;
    }

    .cancel-link,
    .actions-footer__right /deep/ .el-button {
      width: 100%;
    }

    .button-over { min-width: 100%; }

    .upload-toolbar { flex-direction: column; align-items: flex-start; }
    .upload-right { min-width: 100%; }

    .album-preview-dialog /deep/ .el-dialog {
      width: 94% !important;
      margin-top: 6vh !important;
    }

    .album-preview-dialog /deep/ .el-dialog__body {
      padding: 12px;
    }

    .centered-image {
      max-height: 56vh;
      border-radius: 10px;
    }

    .button-container {
      grid-template-columns: 1fr;
      gap: 8px;
      margin-top: 4px;
    }

    .button-container /deep/ .el-button {
      width: 100%;
    }
  }
}
</style>
